import React, { Component } from 'react'
import { imageAddress, translate } from '../../utils/useful'
import ButtonAnimated from '../buttons/ButtonAnimated'

export default class RequestToJoinMeeting extends Component {
    render() {
        return (
            <div className='px-3 py-3 br-10  w-100 ' style={{ position: 'fixed', top: 15, left: 65, zIndex: 99, background: '#fff', boxShadow: '0px 0px 50px #10101060', width: '90%', maxWidth: 360 }}>
                <div className='flexc mb-1 '>
                    <div className='flexc w-100 pb-2' style={{ borderBottom: '1px solid #eee' }}>
                        <img className='br-50 image-cover' width={40} height={40} src={imageAddress(this.props.data?.peer_image, 'profile', 'thumb')} alt="" />
                        <div className='mld-3'>
                            <p className='font-size-16 weight-500 main-c3'>{this.props.data?.peer_name}</p>
                            {/* <p className='font-size-12 weight-500 main-c7'>@{this.props.data?.username}</p> */}
                            <p className='font-size-13 main-c7'>{translate('wants to join this call')}</p>
                        </div>
                    </div>
                </div>
                <p className='font-size-12 main-c7 py-1'>{translate('As the host, do you admin this person to join? you can remove anyone at any time')}</p>
                <div style={{ justifyContent: 'end' }} className='flexc mt-2'>

                    <ButtonAnimated
                        iconwidth='24px'
                        onClick={() => this.props.approveRequest(false, this.props.data.userId)}
                        title={translate('Deny')}
                        // icon='/assets/icons/plus-white.svg'
                        textColor={'#777'}
                        invert={false}
                        bg={'#eee'}
                        isLoading={this.props.isLoadingApproveRequest[this.props.data.userId] == false}
                    />

                    <div className='mld-3'>
                        <ButtonAnimated
                            iconwidth='24px'
                            onClick={() => this.props.approveRequest(true, this.props.data.userId)}
                            title={translate('Admit')}
                            icon='/assets/icons/angle-right-white2.svg'
                            textColor={'#fff'}
                            invert={false}
                            bg={'linear-gradient(90deg, #5856D6, #7D7AFF)'}
                            isLoading={this.props.isLoadingApproveRequest[this.props.data.userId] == true}
                        />
                    </div>


                    {/* <button className='mrd-3 gray-btn w-100 br-30' onClick={() => this.props.approveRequest(false, this.props.data.user_id)}>
                        <p className=' text-small fw-600 py-2' style={{ color: '#777' }}>{translate('rooms.Deny')}</p>
                    </button>
                    <button className='mld-3 green-box-fill w-100 br-30' onClick={() => this.props.approveRequest(true, this.props.data.user_id)}>
                        <p className='text-small fw-600 py-2'>{translate('rooms.Admit')}</p>
                    </button> */}
                </div>

            </div>
        )
    }
}
